document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  /* ========================================
     ページ判定
  ======================================== */
  const path = window.location.pathname.replace(/\/$/, '');

  const isHome =
    body.classList.contains('template-index') ||
    path === '' ||
    path === '/' ||
    path === '/ja' ||
    path === '/index';

  body.classList.remove('is-home', 'is-not-home');
  body.classList.add(isHome ? 'is-home' : 'is-not-home');

  let lastScrollY = window.scrollY;
  const threshold = 6;
  const hideAfter = 80;

  function setTop() {
    header.classList.add('is-top');
    header.classList.remove('is-scrolled', 'is-hidden', 'is-visible');
  }

  function setVisible() {
    header.classList.remove('is-top', 'is-hidden');
    header.classList.add('is-scrolled', 'is-visible');
  }

  function setHidden() {
    header.classList.remove('is-top', 'is-visible');
    header.classList.add('is-scrolled', 'is-hidden');
  }

  function updateHeader(force) {
    const current = window.scrollY;
    const diff = current - lastScrollY;

    /* 先頭付近は必ずトップ状態 */
    if (current <= 5) {
      setTop();
      lastScrollY = current;
      return;
    }

    if (!force && Math.abs(diff) < threshold) return;

    if (diff > 0 && current > hideAfter) {
      setHidden();
    } else if (diff < 0 || force) {
      setVisible();
    }

    lastScrollY = current;
  }

  /* 初期状態を確実に反映 */
  if (window.scrollY <= 5) {
    setTop();
  } else {
    setVisible();
  }

  window.addEventListener('scroll', function () {
    updateHeader(false);
  }, { passive: true });

  window.addEventListener('load', function () {
    updateHeader(true);
  });

  window.addEventListener('pageshow', function () {
    updateHeader(true);
  });

  window.addEventListener('resize', function () {
    updateHeader(true);
  });
});


/* ========================================
   横スクロールを自動検出してドラッグ対応
======================================== */
document.addEventListener('DOMContentLoaded', function () {
  let activeScroller = null;
  let isPointerDown = false;
  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;

  function findScrollableX(el) {
    let node = el;
    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      const canScrollX =
        node.scrollWidth > node.clientWidth + 10 &&
        (style.overflowX === 'auto' ||
          style.overflowX === 'scroll' ||
          style.overflowX === 'hidden');
      if (canScrollX) return node;
      node = node.parentElement;
    }
    return null;
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;

    const scroller = findScrollableX(e.target);
    if (!scroller) return;

    activeScroller = scroller;
    isPointerDown = true;
    isDragging = false;
    startX = e.clientX;
    startScrollLeft = scroller.scrollLeft;

    activeScroller.classList.add('drag-scroll-target');
    activeScroller.style.cursor = 'grabbing';
  }, { passive: true });

  document.addEventListener('pointermove', function (e) {
    if (!isPointerDown || !activeScroller) return;

    const dx = e.clientX - startX;

    if (Math.abs(dx) > 5) {
      isDragging = true;
    }

    if (isDragging) {
      e.preventDefault();
      activeScroller.scrollLeft = startScrollLeft - dx;
      activeScroller.classList.add('is-dragging');
    }
  }, { passive: false });

  function endDrag() {
    if (!activeScroller) return;

    activeScroller.style.cursor = 'grab';

    setTimeout(() => {
      if (activeScroller) {
        activeScroller.classList.remove('is-dragging');
      }
      isDragging = false;
    }, 30);

    isPointerDown = false;
    activeScroller = null;
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest('a, img')) {
      e.preventDefault();
    }
  });

  document.addEventListener('click', function (e) {
    if (isDragging && e.target.closest('a')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
});